import React from "react";
import { CustomTextField } from "../../../components/TextFields";
import { Button } from "@mui/material";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../../components/Button";
import { useModal } from "../../../components/modal";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFieldArray, useForm } from "react-hook-form";
import AnsawersTable from "./ansawers";
import { useAddQuestionsMutation } from "../../../app/services/questions.api";
import LoadingButton from "../../../components/Button/LoadingButton";

const schema = yup.object().shape({
  title: yup.string().required("عنوان الزامی است."),
  options: yup.array().of(yup.string().required()).length(4),
  answer: yup.number().min(1).max(4).required(),
});
export default function AddModal({ quizeId }: { quizeId: string }) {
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { options: ["", "", "", ""] },
  });
  const { setShow } = useModal();
  const { update } = useFieldArray({ control, name: "options" as never });
  const [addQuestion, addState] = useAddQuestionsMutation();

  return (
    <React.Fragment>
      <CustomTextField
        required
        label="عنوان"
        placeholder="عنوان را وارد کنید."
        variant="outlined"
        onChange={(e) => setValue("title", e.target.value)}
        defaultValue={getValues("title")}
        error={!!errors.title}
        helperText={errors.title?.message}
        multiline
        minRows={2}
        maxRows={4}
      />
      <AnsawersTable
        error={!!errors.options}
        helperText={errors?.options?.message}
        onChange={(value, index) => update(index, value)}
        defaultValue={getValues("options")}
      />
      <CustomTextField
        required
        label="پاسخ سوال"
        type="number"
        placeholder="گزینه درست را وارد کنید"
        variant="outlined"
        onChange={(e) => setValue("answer", Number(e.target.value))}
        defaultValue={getValues("answer")}
        error={!!errors.answer}
        helperText={errors.answer?.message}
        style={{ width: "50%" }}
      />
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          isLoading={addState.isLoading}
          onClick={handleSubmit(
            (data) => {
              data.answer -= 1;
              //@ts-ignore
              addQuestion({ quizeId, data })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            },
            (err) => {
              console.error(err);
            }
          )}
        >
          تایید
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
